import { ApiParameters } from './api-parameters';
import { Order } from '../../interfaces/order';
import { Share } from '../../interfaces/share';
import { ApiDeleteRequest } from './api-delete-request';

export class ShareDeleteReservationRequest extends ApiDeleteRequest
{
    public constructor(order: Order, share: Share, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('orderid', order.Id)
            .addQueryParameter('ticketnumber', share.Ticket.TicketNumber)
            .addQueryParameter('shareletter', share.Name);

        super('sharereservation', parameters, null, null, webapiBasepath);
    }
}
